// BillersStyles.js
import styled from 'styled-components';

export const ViewComparisonButton = styled.button`
  background: none;
  border: none;
  color: yellow;
  cursor: pointer;
  font-size: 0.875rem;
`;

export const FormWrapper = styled.form`
  margin-top: 20px;
  margin-left: 20px;
  padding: 1.5rem;
  background-color: #333131;
  border: 1px solid #ccc;
  border-radius: 8px;
  color: #fff;
  margin-bottom: 2rem;
  font-size: 1rem;
  max-width: 500px;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 0.875rem;
    margin-left: 0;
    margin-right: 0;
    padding: 1rem;
    max-width: 100%;
    border-radius: 6px;
  }
`;

export const PlannerFormWrapper = styled.form`
  margin-top: 20px;
  margin-left: 20px;
  padding: 20px;
  background-color: #333131;
  border: 1px solid #ccc;
  border-radius: 8px;
  color: #fff;
  max-width: 80%;
  width: 100%;

  @media (max-width: 768px) {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
    padding: 1rem;
    overflow-x: auto;
  }
`;

export const FormRow = styled.div`
  margin-bottom: 15px;

  label {
    display: block;
    margin-bottom: 5px;
  }

  input,
  textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #444;
    color: #fff;
    max-width: 400px;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  @media (max-width: 768px) {
    font-size: 0.875rem;
    input,
    textarea {
      max-width: 100%;
    }
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #fff;
  font-size: 1rem;

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const InputField = styled.input`
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  background-color: #f8f8f8;
  width: 100%;
  max-width: 400px;
  font-size: 1rem;

  @media (max-width: 768px) {
    font-size: 0.875rem;
    max-width: 100%;
  }
`;

export const CheckBox = styled.input`
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  background-color: #f8f8f8;
`;

export const AllocationInput = styled.input`
  padding: 0.5rem;
  max-width: 80px;
  border-radius: 4px;
  background-color: #f8f8f8;
`;

export const DateInputField = styled.input.attrs({ type: 'date' })`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
  color: #333;
  font-size: 14px;
  max-width: 400px;

  &:focus {
    border-color: #007bff; /* Add a highlight color for focus */
    outline: none;
  }

  &::-webkit-calendar-picker-indicator {
    cursor: pointer; /* Ensures the calendar icon is clickable */
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
  max-width: 400px;
`;

export const SubmitButton = styled.button`
  width: 30%;
  min-width: 100px;
  margin-right: 10px;
  padding: 10px;
  background-color: #007bff;
  border: none;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 480px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }
`;

export const CancelButton = styled.button`
  width: 30%;
  min-width: 100px;
  margin-left: auto;
  padding: 10px;
  background-color: rgb(220, 74, 16);
  border: none;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 480px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const AddButton = styled.button`
  padding: 8px 16px;
  background-color: #28a745;
  border: none;
  color: #fff;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 15px;

  &:hover {
    background-color: #218838;
  }

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;

  h1, h2 {
    font-size: clamp(1.1rem, 4vw, 1.5rem);
  }
`;

export const PageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;

export const ContentContainer = styled.div`
  flex-grow: 1;
  margin-top: 50px;
  padding: 20px;
  transition: margin-left 0.3s ease-in-out;
`;

export const TableWrapper = styled.div`
  padding: 20px;
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 0.875rem;
    padding: 10px;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  min-width: 600px;

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const TableHeader = styled.th`
  padding: 10px;
  background-color:rgb(51, 47, 47);
  border: 1px solid #ddd;
  text-align: left;
`;

export const TableRow = styled.tr`
  &:hover {
    background-color:rgb(113, 109, 109);
  }
  
  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const TableData = styled.td`
  word-wrap: break-word;
  white-space: normal;
  padding: 10px;
  border: 1px solid #ddd;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  color: red;
  cursor: pointer;
  font-size: 16px;
`;

export const EditButton = styled.button`
  background: none;
  border: none;
  color: green;
  cursor: pointer;
  font-size: 16px;
`;

export const ViewPaymentsButton = styled.button`
  background: none;
  border: none;
  color: gray;
  cursor: pointer;
  font-size: 16px;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: bold;
  text-align: center;
  background-color: ${props => props.color || '#9E9E9E'};
  color: #fff;
  white-space: nowrap;
  
  @media (max-width: 768px) {
    font-size: 0.625rem;
    padding: 3px 8px;
  }
`;


export const PaginationControlStyle = styled.button`
  margin-top: 10px;
  background: none;
  border: none;
  color: white;
  font-size: 16px;
`;

export const DropdownWrapper = styled.div`
  .form-select {
    background-color: #f8f9fa;
    border-radius: 0.25rem;
    border: 1px solid #ced4da;
    transition: background-color 0.3s ease, border-color 0.3s ease;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
  }

  .form-select:focus {
    background-color: #fff;
    border-color: #80bdff;
    box-shadow: 0 0 0 0.25rem rgba(38, 143, 255, 0.25);
  }
  
  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const SignupDropdownWrapper = styled.div`
  select {
    margin-bottom: 15px;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #444; /* Dark border */
    border-radius: 5px;
    width: 100%;
    background-color: #2e2e2e; /* Dark input background */
    color: #e0e0e0; /* Light text inside the dropdown */
    max-width: 400px;
    transition: border-color 0.3s ease;
  }

  select:focus {
    outline: none;
    border-color: #4caf50; /* Green border on focus */
  }

  option {
    background-color: #2e2e2e; /* Dark background for options */
    color: #e0e0e0; /* Light text for options */
  }

  select:hover {
    border-color: #45a049; /* Darker green border on hover */
  }
`;

